module.exports = __webpack_public_path__ + "static/media/illustration-direct-adding-a-client.952c6783.png";